import { handleActions } from 'redux-actions';
import * as updateVehicleActions from '../actions/updateVehicleActions';
import { combineReducers } from 'redux';

const initState = {
  putArchive: {
    Status: null,
    archivingError: null,
  },
  restoreArchive: {
    Status: null,
    restoreError: null,
  },
};

const archivingVehicleStatus = handleActions(
  {
    [updateVehicleActions.archiveVehicle]: (state, _action) => {
      return { ...state, Status: 'loading' };
    },
    [updateVehicleActions.archiveVehicleSuccess]: (state, _action) => {
      return { ...state, Status: 'success' };
    },
    [updateVehicleActions.archiveVehicleError]: (state, action) => {
      let { payload } = action;
      console.log('archivingVehicle Error', payload);
      return { ...state, Status: 'error', updatingError: payload };
    },
  },
  initState.putArchive
);

const restoringVehicleStatus = handleActions(
  {
    [updateVehicleActions.restoreVehicle]: (state, _action) => {
      return { ...state, Status: 'loading' };
    },
    [updateVehicleActions.restoreVehicleSuccess]: (state, _action) => {
      return { ...state, Status: 'success' };
    },
    [updateVehicleActions.restoreVehicleError]: (state, action) => {
      let { payload } = action;
      console.log('restoreVehicle Error', payload);
      return { ...state, Status: 'error', updatingError: payload };
    },
  },
  initState.putArchive
);

export const vehicleStatus = combineReducers({
  archivingVehicleStatus,
  restoringVehicleStatus,
});
